'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resetCookies;

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var removeCookie = function removeCookie(name) {
  _reactCookie2.default.remove(name, { path: '/' });

  var parts = location && location.hostname ? location.hostname.split('.') : [];

  while (parts.length > 0) {
    var domain = parts.join('.');
    _reactCookie2.default.remove(name, { path: '/', domain: domain });
    _reactCookie2.default.remove(name, { path: '/', domain: '.' + domain });
    parts.shift();
  }
};

function resetCookies() {
  removeCookie('orderNumber');
  removeCookie('orderToken');
  removeCookie('hasOrder');
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/resetCookies.js
// module id = 605
// module chunks = 0